import React, { Fragment } from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const planillas = [{
  emoji: '📄',
  title: 'Banco de Objetivos',
  desc: 'Objetivos listos para copiar y adaptar por patología y etapa del tratamiento.'
}, {
  emoji: '📄',
  title: 'Ficha de Admisión',
  desc: 'Datos del paciente, antecedentes, hábitos y motivo de consulta.'
}, {
  emoji: '📄',
  title: 'Ficha de Seguimiento',
  desc: 'Evolución por área a lo largo del proceso: peso, adherencia y objetivos.'
}, {
  emoji: '📄',
  title: 'Plan Semanal',
  desc: 'Estructura de plan alimentario semanal lista para completar y entregar.'
}, {
  emoji: '📄',
  title: 'Planificador Semanal',
  desc: 'Organización de objetivos y propuestas por semana de tratamiento.'
}, {
  emoji: '📄',
  title: 'Seguimiento Diario',
  desc: 'Registro diario de hábitos, comidas y adherencia para el paciente.'
}];
const steps = [{
  num: '1',
  label: 'MegaPack Base',
  active: false
}, {
  num: '2',
  label: 'Gestión Completa',
  active: true
}, {
  num: '3',
  label: 'Consultorio Profesional',
  active: false
}];
export function Bonuses() {
  useTrackSection('bonuses', 'Bonuses Section');
  return <section id="bonuses" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,250,252) 0%, rgb(220,252,231) 20%, rgb(220,252,231) 80%, rgb(248,250,252) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-52">
      <div className="mx-auto max-w-4xl" data-id="element-53">
        {/* Stepper */}
        <div className="mx-auto mb-10 max-w-xs sm:max-w-md px-8 flex items-center justify-between" data-id="element-54">
          {steps.map((step, i) => <Fragment key={step.num} data-id="element-55">
              <div className="relative flex-shrink-0" data-id="element-56">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-black shadow-sm" style={{
              backgroundColor: step.active ? 'rgb(21,128,61)' : 'rgb(187,247,208)',
              color: step.active ? '#ffffff' : 'rgb(21,128,61)',
              border: step.active ? '2px solid rgb(21,128,61)' : '2px solid rgb(134,239,172)',
              transform: step.active ? 'scale(1.15)' : 'scale(1)'
            }} data-id="element-57">
                  {step.num}
                </div>
                <span className="absolute top-full left-1/2 -translate-x-1/2 mt-1 text-[10px] font-bold text-center leading-tight w-[72px]" style={{
              color: step.active ? 'rgb(21,128,61)' : 'rgb(134,239,172)'
            }} data-id="element-58">
                  {step.label}
                </span>
              </div>
              {i < steps.length - 1 && <div className="flex-1 h-0.5 mx-2" style={{
            backgroundColor: i === 0 ? 'rgb(21,128,61)' : 'rgb(187,247,208)'
          }} data-id="element-59" />}
            </Fragment>)}
        </div>

        {/* Offer badge */}
        <div className="flex justify-center mb-4" data-id="element-60">
          <div className="flex flex-col items-center gap-1 text-white rounded-full px-10 py-3 shadow-md" style={{
          background: 'linear-gradient(135deg, rgb(15,100,50) 0%, rgb(21,128,61) 100%)'
        }} data-id="element-61">
            <span className="text-xs font-black uppercase tracking-[3px] text-white" data-id="element-62">
              ⭐ Oferta 2
            </span>
            <span className="text-base font-black text-white leading-tight" data-id="element-63">
              MegaPack Gestión Completa
            </span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-64">
          Todo lo anterior, más:
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-65">
          6 planillas profesionales listas para usar en el consultorio desde el
          primer día
        </p>

        {/* Oferta 1 incluida */}
        <div className="flex items-center gap-3 bg-white rounded-xl px-5 py-4 mb-6 shadow-sm" style={{
        border: '1px solid rgba(34,197,94,0.20)'
      }} data-id="element-66">
          <span className="text-xl" data-id="element-67">✅</span>
          <div data-id="element-68">
            <span className="block text-sm font-black text-gray-900" data-id="element-69">
              MegaPack Base completo incluido
            </span>
            <span className="text-xs text-gray-500" data-id="element-70">
              6 Tomos · +350 páginas · 6 Bonos · Sistema Clínico Completo
            </span>
          </div>
        </div>

        {/* Header planillas */}
        <div className="rounded-t-xl px-5 py-4" style={{
        background: 'linear-gradient(135deg, rgb(15,100,50) 0%, rgb(21,128,61) 100%)',
        border: '2px solid rgb(21,128,61)',
        borderBottom: 'none'
      }} data-id="element-71">
          <p className="text-[10px] font-bold uppercase tracking-widest text-white/70 m-0 mb-1" data-id="element-72">
            Exclusivo Oferta 2
          </p>
          <h3 className="text-base font-black text-white m-0" data-id="element-73">
            📋 6 Planillas Profesionales Editables
          </h3>
          <p className="text-xs text-white/80 m-0 mt-1" data-id="element-74">
            Listas para usar en consultorio — sin adaptar, sin improvisar
          </p>
        </div>

        {/* Cards grilla 2x3 */}
        <div className="rounded-b-xl overflow-hidden shadow-lg" style={{
        border: '2px solid rgb(21,128,61)',
        borderTop: 'none'
      }} data-id="element-75">
          <div className="bg-white p-4 grid grid-cols-2 gap-3" data-id="element-76">
            {planillas.map((item, i) => <div key={i} className="flex flex-col gap-2 rounded-xl p-4" style={{
            backgroundColor: 'rgba(34,197,94,0.03)',
            border: '1px solid rgba(34,197,94,0.15)'
          }} data-id="element-77">
                <div className="flex items-center justify-between" data-id="element-78">
                  <span className="text-2xl" data-id="element-79">{item.emoji}</span>
                  <span className="text-[10px] font-black rounded-full px-2 py-0.5" style={{
                color: 'rgb(21,128,61)',
                border: '1px solid rgba(34,197,94,0.30)',
                backgroundColor: 'white'
              }} data-id="element-80">
                    INCLUIDA
                  </span>
                </div>
                <span className="text-sm font-black text-gray-900 leading-tight" data-id="element-81">
                  {item.title}
                </span>
                <span className="text-xs text-gray-500 leading-snug" data-id="element-82">
                  {item.desc}
                </span>
              </div>)}
          </div>

          {/* Footer */}
          <div className="px-5 py-3 flex items-center justify-between" style={{
          backgroundColor: 'rgba(34,197,94,0.05)'
        }} data-id="element-83">
            <p className="text-xs text-gray-500 m-0" data-id="element-84">
              Editables · Imprimibles · Listas para usar
            </p>
            <span className="text-[10px] font-black text-white rounded-full px-3 py-1" style={{
            backgroundColor: 'rgb(21,128,61)'
          }} data-id="element-85">
              6 PLANILLAS
            </span>
          </div>
        </div>
      </div>
    </section>;
}